__turbopack_context__.v({
  "className": "anton_b7f15df-module__I6UpSW__className",
});
